import { ClassNamesConfig, GroupBase } from "react-select";
import { SelectItem } from "./Select";

export const classNames = (
  invalid?: boolean,
): ClassNamesConfig<SelectItem, false, GroupBase<SelectItem>> => ({
  control: (state) =>
    `${state.isFocused ? "!border-unset outline-hidden" : ""} 
  ${state.menuIsOpen ? "!rounded-b-none" : ""} 
  !hover:border-secondary
 !rounded-[10px] border
 !shadow-none
  ${invalid ? "!border-error text-error placeholder-error" : "!border-gray-accent"} 
  ${Array.isArray(state.selectProps.value) && state.selectProps.value.length > 1 ? "p-1.5" : "p-3"}  text-[14px]/[20px]`,
  valueContainer: () =>
    "text-secondary !p-0 font-medium !flex !flex-row !flex-nowrap",
  placeholder: (state) =>
    `${state.isFocused ? "hidden" : ""} !text-secondary !mx-0 font-medium`,
  input: () => "!m-0 !p-0",
  indicatorSeparator: () => "!hidden",
  clearIndicator: () => "!p-0 !mr-1",
  dropdownIndicator: () => "!text-secondary !p-0",
  option: (state) =>
    `${state.isSelected ? "!bg-gray-accent/20 !text-secondary" : "!bg-transparent"} hover:!bg-gray-accent/30 !w-full !my-0 !rounded-[4px] !p-2 !cursor-pointer !text-[14px]/[20px] !font-medium !tracking-[-0.14px]`,
  menu: () =>
    "!mt-0 !rounded-[10px] border-gray-accent !border-t-0 !rounded-t-none !shadow-gray-default border !border-gray-accent",
  menuList: () => "!px-2.5",
});
